var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVkOneTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.88889C0 3.97969 3.97969 0 8.88889 0H31.1111C36.0203 0 40 3.97969 40 8.88889V31.1111C40 36.0203 36.0203 40 31.1111 40H8.88889C3.97969 40 0 36.0203 0 31.1111V8.88889Z",
    fill: "#0077FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4059 11.4059C10 12.8118 10 15.0745 10 19.6V20.4C10 24.9255 10 27.1882 11.4059 28.5941C12.8118 30 15.0745 30 19.6 30H20.4C24.9255 30 27.1882 30 28.5941 28.5941C30 27.1882 30 24.9255 30 20.4V19.6C30 15.0745 30 12.8118 28.5941 11.4059C27.1882 10 24.9255 10 20.4 10H19.6C15.0745 10 12.8118 10 11.4059 11.4059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6773 24.4444C16.1732 24.4444 13.4406 21.3136 13.3335 16.1111H15.6147C15.6858 19.9327 17.4213 21.5522 18.7517 21.8852V16.1111H20.9378V19.4092C22.2211 19.2667 23.5642 17.7665 24.0157 16.1111H26.1674C25.8231 18.1468 24.3608 19.6469 23.3277 20.2657C24.3616 20.7661 26.0252 22.0757 26.6668 24.4444H24.3017C23.8023 22.861 22.579 21.6346 20.9386 21.4681V24.4444H20.6773Z",
    fill: "#0077FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkOneTap);
export default __webpack_public_path__ + "static/media/VKOneTap.efde56f98b73fdf569077c794bdac9ba.svg";
export { ForwardRef as ReactComponent };